














































































import { BlogManagerArticleService as blogApi } from "@/common/api";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import { STATUS, STATUS_NAME } from "@/model/news";
import PaginateModel from "@/model/paginate";
import { STATUS_ARRAY } from "@/model/releaseSetting";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "BlogListComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    QMultiSelect,
  },
})
export default class BlogListComponent extends Vue {
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public initHeaders = [
    { id: "created_at", name: "作成日", order: "desc" },
    { id: "post_date", name: "公開日時", order: "" },
    { id: "created_by", name: "作成者", order: "" },
    { id: "title", name: "タイトル" },
    { id: "open_status", name: "状態", order: "" },
    { id: "", name: "" },
  ];

  public selectedAllStatus = { id: "all", name: "すべてのステータス" };
  public statuses = [...[this.selectedAllStatus], ...STATUS_ARRAY];

  public headers = [];

  public articles = [];

  public initSearch = {
    status: ["all"],
    title: "",
    sort: "created_at",
    direction: "desc",
    perPage: 30,
    currentPage: 1,
  };

  public searchParams: any = {};

  public mounted() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.initalSearch();
    this.filterData();
  }

  public initalSearch(): void {
    const query = this.$router.currentRoute.query;
    this.searchParams = {
      ...this.initSearch,
      ...query,
    };
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    this.$router
      .replace({ name, params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    let message: any;
    try {
      if (query.category && query.category.includes("all")) {
        query.category = [];
      }

      if (query.status && query.status.includes("all")) {
        query.status = [];
      }
      if (!Array.isArray(query.status)) {
        query.status = [query.status];
      }
      const result = await blogApi.adminArticle(query);
      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });
      this.articles = result.data.articles;
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public clear() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.$router.replace({ query: {} });
    this.doSearch();
  }
  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initSearch };
  }

  public getStatus(item): string {
    if (item.open_status === STATUS.RELEASE) {
      const date = new Date(item.post_date);
      const today = new Date();
      if (date > today) {
        return STATUS_NAME[STATUS.WAIT];
      }
    }
    return STATUS_NAME[item.open_status];
  }
}
